import { wave, waveV3 } from '@/api/config';
import { Shop } from '@/store/shop';

export async function createUserLists(label, authorization, locale) {
  const headers = {
    appId: process.env.appId,
    authorization: `Bearer ${authorization}`,
    'Accept-Language': locale,
  };
  try {
    const response = await waveV3.post(`/lists`, { label: label }, { headers });
    return { data: response?.data || [] };
  } catch (error) {
    return { data: [], error };
  }
}

export async function getUserListsV3() {
  const shopId = Shop?.getValue()?.selectedShop?._id;
  try {
    const params = {
      withProductPreviewCount: 4,
      ...(shopId && { shop: shopId }),
    };
    const response = await wave.get(`/v3.1/lists`, { params });
    return { data: response?.data || [] };
  } catch (error) {
    return { data: [], error };
  }
}

export async function updateUserLists(authorization, id, action, products) {
  try {
    const response = await waveV3.put(`/lists/${id}/products`, { action, products });
    return { data: response?.data?.payload || [] };
  } catch (error) {
    return { data: [], error };
  }
}

export async function deleteUserList(authorization, id) {
  const headers = {
    appId: process.env.appId,
    authorization: `Bearer ${authorization}`,
  };
  try {
    const response = await waveV3.delete(`/lists/${id}`, { headers });
    return { data: response?.data?.payload || [] };
  } catch (error) {
    return { data: [], error };
  }
}

export async function editUserList(authorization, id, label) {
  const headers = {
    appId: process.env.appId,
    authorization: `Bearer ${authorization}`,
  };
  try {
    const response = await waveV3.patch(`/lists/${id}`, { label }, { headers });
    return { data: response?.data?.payload || [] };
  } catch (error) {
    return { data: [], error };
  }
}

export async function getUserListsProductsV3(authorization, id, resource) {
  const shopId = Shop?.getValue()?.selectedShop?._id;

  const headers = {
    appId: process.env.appId,
    authorization: `Bearer ${authorization}`,
  };
  try {
    const response = await wave.get(`/v3.1/lists/${id}/products`, {
      params: { ...resource, ...(shopId && { shop: shopId }) },
      headers,
    });
    return { data: response?.data || [] };
  } catch (error) {
    return { data: [], error };
  }
}

export function getFrequentlyBoughtTogether(id, locale) {
  const shopId = Shop?.getValue()?.selectedShop?._id;

  const headers = {
    appId: process.env.appId,
    'x-api-key': process.env.PRIVATE_API_KEY || undefined,
    'Accept-Language': locale,
  };

  const params = {
    valid: true,
    ...(shopId && { shop: shopId }),
  };

  return wave.get(`/v3.1/lists/frequently-bought-together/${id}`, { headers, params });
}

export function getSimilarProducts(id, locale) {
  const shopId = Shop?.getValue()?.selectedShop?._id;

  const params = {
    ...(shopId && { shop: shopId }),
  };

  const headers = {
    appId: process.env.appId,
    'x-api-key': process.env.PRIVATE_API_KEY || undefined,
    'Accept-Language': locale,
  };

  return wave.get(`/v3.1/lists/similar-products/${id}?valid=true`, { headers, params });
}
